export default store => {
    store.subscribe((mutation) => {
        if (mutation.type === 'addToSavedComments' || mutation.type === 'updateSavedComment' || mutation.type === 'deleteSavedComment') {
            store.dispatch('SAVE_SAVED_COMMENTS')
        }
    })
}
